import {getToken} from '../services/api';
import {STORAGE_TOKEN} from "../config/common";

let timer = undefined;

/**
 * 检测是否是空对象
 * @param obj
 * @returns {boolean}
 */
export function isEmptyObject(obj) {
    for (let key in obj) {
        return false;
    }
    return true;
}

/**
 * 转换UTC时间为本地时间
 * @param utcTime
 */
export function transTimeToPekin(utcTime = undefined) {
    if (utcTime) {
        return new Date(utcTime).format('yyyy-MM-dd hh:mm:ss');
    }
}

/**
 * 转换时间
 * @param dateTime
 * @param format
 */
export function formatDateTime(dateTime, format) {
    return dateTime.format(format);
}

/**
 * 轮询token
 */
export function loopToken() {
    if (timer) {
        clearInterval(timer);
    }
    let token;
    try {
        token = JSON.parse(localStorage.getItem(STORAGE_TOKEN));
    } catch (e) {
        clearInterval(timer);
        location.hash = '#/login';
        throw e;
    }
    if (token && typeof token === 'object') {
        setTimeout(() => {
            getToken(token.refresh_token).then(res => {
                localStorage.setItem(STORAGE_TOKEN, JSON.stringify(res));
            });
        }, 5000);
        timer = setInterval(() => {
            getToken(token.refresh_token).then(res => {
                localStorage.setItem(STORAGE_TOKEN, JSON.stringify(res));
            });
        }, 5 * 60 * 1000); // 25分钟刷新token
    } else {
        clearInterval(timer);
        location.hash = '#/login';
    }
}

/**
 * 格式化参数
 */
export function formateParams(params) {
    let newParams = {};
    for (let key in params) {
        if (params[key] !== undefined && params[key] !== "" && params[key] !== null) {
            newParams[key] = params[key]
        }
    }
    return newParams;
}
